import { memo } from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow, Typography } from "@mui/material";

import { convertDateArrayToDate } from "utils";

const formatCellValue = (value) =>
  Array.isArray(value) ? convertDateArrayToDate(value) : value ?? "-";

const UploadRowsTableRow = ({ row, visibleColumns }) => (
  <TableRow hover>
    {visibleColumns.map(({ key }) => (
      <TableCell key={key}>
        <Typography variant="body2">{formatCellValue(row?.[key])}</Typography>
      </TableCell>
    ))}
  </TableRow>
);

UploadRowsTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  visibleColumns: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, label: PropTypes.string }),
  ).isRequired,
};

export default memo(UploadRowsTableRow);
